export const postHeaderRegex = /^---([\S\s]*)---\n/g;
